export const replaceHyphen = (str) => str.replace(/-/g, ' ');
